import { State } from '../../typings'

export const setAnchorElProducer = (
  state: State,
  payload: HTMLElement | null,
): State => ({
  ...state,
  anchorEl: payload,
})
